export interface IFailedUpload {
  id: number;
  date: string;
  instituteId: number;
  instituteName: string;
  fileName: string;
  errorMessage: string;
  fileAvailable: boolean;
}

export interface IFailedUploadQueryResult {
  pageNumber: number;
  totalPages: number;
  elementsPerPage: number;
  totalElementCount: number;
  firstPage: boolean;
  lastPage: boolean;
  empty: boolean;
  elements: IFailedUpload[];
}

export interface IFailedUploadFetchRequest {
  instituteId: number;
  page: number;
  pageSize: number;
}

export enum FailedUploadActionTypes {
  FETCH_REQUEST = "@@failedupload/FETCH_REQUEST",
  FETCH_SUCCESS = "@@failedupload/FETCH_SUCCESS",
  FETCH_ERROR = "@@failedupload/FETCH_ERROR",
}

export interface IFailedUploadState {
  readonly loading: boolean;
  readonly data: IFailedUploadQueryResult;
  readonly errors?: string;
}

export const emptyQueryResult: IFailedUploadQueryResult = {
  pageNumber: 0,
  totalPages: 0,
  elementsPerPage: 0,
  totalElementCount: 0,
  firstPage: false,
  lastPage: false,
  empty: true,
  elements: []
}
